import type { FaireProductEntity } from "../../entity_types/product";

export const p_pzm7n52pjh: FaireProductEntity = {
  token: "p_pzm7n52pjh",
  type: "product",
  name: "100% Merino Wool Unisex Mens Knit Scarf",
  brandToken: "b_nkbvwqtp9e",
  brandName: "Vobelle",
  imageUrl:
    "https://cdn.faire.com/fastly/f523535c9ca334113cd315193a2c873c35e2b938bbd1d45bfe301bdfd614ad3a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f4b0486da5353c1e9c0e85326f0ae30d5c4440f459e73286c7beddfcb44e8d6.webp",
    "https://cdn.faire.com/fastly/1b958214206134a5a7c6ff4f2fdc92da94ba46b9ef9e95996dd44244a9a82cd5.png",
    "https://cdn.faire.com/fastly/25ed9e52092246c70abff780c28831028f36911bd44e5f103c519e15c3bddd03.png",
    "https://cdn.faire.com/fastly/a00d89076d7eaeabd5b09dd67ac47690fa26f60fa792dc2449cc0a699750f6fe.webp",
    "https://cdn.faire.com/fastly/d654bbe6df2c8768adb47427e1a8cbbdc76274f853474468a245889b16d648f7.jpeg",
    "https://cdn.faire.com/fastly/7611f3b946a945ef69283aea67428c6e74de9c20ac0aa865bd7e662bda790f26.webp",
    "https://cdn.faire.com/fastly/7f4c4b84051795d724c04c41fffb08797a5c3f3f75d7abbc1b0cde46dd382051.webp",
    "https://cdn.faire.com/fastly/feb80520d6b309a18ed33d21efad7d42445c1108ce9cf8b352031dd51fd0182b.jpeg",
    "https://cdn.faire.com/fastly/d3babd4292c704ab7968124fb4185c564f03f05334b459999270794b682065f3.webp",
    "https://cdn.faire.com/fastly/193d27541fb792a19acaac49e2fa07b07f56767b2533fe4f60115651bcd442bd.webp",
    "https://cdn.faire.com/fastly/6a9ce7ab733cf7abb4c8a24e12b07b72446fd8ea6275e185a5b31e604c7360c3.webp",
    "https://cdn.faire.com/fastly/0c4128affe682a71d160547a0ed16d92b90b9684a92ac7ea090761b16284747c.png",
    "https://cdn.faire.com/fastly/bd0fc6e01a2df614e7babb5e6fccdc242d8054df1bdedec8d2da104c6f29a15e.jpeg",
    "https://cdn.faire.com/fastly/ae11f81c1486f5d35448d859e0b46ff9ceaa119174a4232c167d8bae73cdd60b.webp",
    "https://cdn.faire.com/fastly/33e52728d8a6839084c475bc5abc8b2cb5e1b994d9385da0e05c23e5ce1a6fcf.webp",
    "https://cdn.faire.com/fastly/50ee583c4c94a2a1d92d583b209fa3f114ba6e264e8e2e7d995bab579b34ecfe.webp",
    "https://cdn.faire.com/fastly/a8aff5733ed029b1124a75aabe5e43632f4756f839b0dbf9e6c5e7b148d1c7e8.webp",
    "https://cdn.faire.com/fastly/1d89b536d66e0d2da1e4a55de40e01a0e417704c1961a9a5683a2855adb8cb64.webp",
    "https://cdn.faire.com/fastly/8d7431f3aeb2737da616e7d27928081093fbc980eac4b3b83464330dfb05b51b.webp",
    "https://cdn.faire.com/fastly/3ffe31814c96f60cd35db6e6629e325f2ffc86b02765c8931fac1e8d83d0b5d1.webp",
    "https://cdn.faire.com/fastly/0674d4c6bfc79888841a18922ad4ab5fb71e0a195050c769db500171572308e5.webp",
    "https://cdn.faire.com/fastly/d392640e61de4f4e1710d6feae48531fd105e319c05ac0447c2b6cdd9dd25bbf.webp",
    "https://cdn.faire.com/fastly/765e73542517d5865baab9c8d52f1eb646365bcca885479fb497d96a752d5d62.png",
    "https://cdn.faire.com/fastly/a66df388cd03f03530bee50541e692aa7ea46b799c823a594f75abdd646c6a85.webp",
    "https://cdn.faire.com/fastly/fa8aeef1f36667ac6cd4351600914b395741216795f67f1a27ac3c38bcc00339.jpeg",
    "https://cdn.faire.com/fastly/6869406333b615551f89bb9d515617b8b06572843102a8541da3f309612fabee.webp",
    "https://cdn.faire.com/fastly/368defedd1224f81d911d5b4b10c08fbc2b70c49e2acbe50f524b6d7a5b9f99a.webp",
    "https://cdn.faire.com/fastly/3ba600594dcaa3d813d32262fc315f77dc00cc7ab61eff8cc787831e7f1568a0.webp",
    "https://cdn.faire.com/fastly/1cfe03e8dd80ecb1fc1cd147495c71c87c6c6738e06b3787547e6a249b4354b5.webp",
    "https://cdn.faire.com/fastly/afe4c76dad383e9ce994adb4b70cc71ddd3f98d6d49be924bc8aa040da36f7ad.webp",
  ],
  priceDollars: 35,
  description:
    'A knit scarf in 100% merino wool, soft and tactile. It’s substantial enough (1/4” thick) to keep you warm yet light enough to wear comfortably all day.\n\n* 100% merino wool. We dye and ply 100% merino wool in small batches, to create our own unique yarns, which are then handmade into knitwear in our studio in CT.\n*  Measures 7” wide by 73" long\n*  Super soft, Non-itchy\n*  Handmade in Killingly, CT\n*  Comes with a Vobelle hang tag that provides country of origin, material and care instruction information.\n',
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:49.997Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
